import { unknownKeyText } from '../../../constants/gridText';

const UnknownFilterRenderer = function (params) {
    return !params.value ? unknownKeyText : params.value;
};

export default UnknownFilterRenderer;
